import { render, staticRenderFns } from "./lighting.vue?vue&type=template&id=ebcb96be&scoped=true"
import script from "./lighting.vue?vue&type=script&lang=js"
export * from "./lighting.vue?vue&type=script&lang=js"
import style0 from "./lighting.vue?vue&type=style&index=0&id=ebcb96be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcb96be",
  null
  
)

export default component.exports